import React from "react";
import avatarGroupguidelines1 from "assets/images/png/avatarGroupguidelines1.png";
import avatarGroupguidelines2 from "assets/images/png/avatarGroupguidelines2.png";

const ComponentPrimaryDatas = [
	{
		id: 1,
		title: "Do",
		titleClassname: "active",
		image: avatarGroupguidelines1,
		description:
			"Incorporate a relevant call to action that clearly directs users towards the desired next step. Ensure it is visually prominent and easy to understand.",
	},
	{
		id: 2,
		title: "Don’t",
		titleClassname: "inactive",
		image: avatarGroupguidelines2,
		description:
			"Don't use a tooltip with an avatar when it's non-interactive or disabled. The tooltip won't work for keyboard users and screen readers.",
	},
];

const GuidelineCardAvatarGroup = () => {
	return (
		<div className="guideline-card d-flex justify-content-between">
			{ComponentPrimaryDatas.map((data) => (
				<div key={data.id} className="guideline-wrapper">
					<h6 className={`guideline-badge plt-body-compact-md dis-mb-8 ${data.titleClassname}`}>{data.title}</h6>
					<div className="guideline-detail-wrapper d-flex align-items-center justify-content-center">
						<div className="guideline-img">
							<img src={data.image} alt="userimage" />
						</div>
					</div>
					<p className="guideline-desc plt-body-md dis-mt-12">{data.description}</p>
				</div>
			))}
		</div>
	);
};

export default GuidelineCardAvatarGroup;
